var map = {
	"./app-store_badge--black.svg": 1537,
	"./background-app-page.jpg": 1538,
	"./icon-app-icon.svg": 1539,
	"./icon-intersport-bookmark.svg": 1540,
	"./logo-intersport.svg": 1541,
	"./play-store_badge--black.svg": 1542
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1536;